import { IGradeBasicData, defaultGradeBasicData } from "../grade/GradeBasicData";
import { IMeasuredPropertyData } from "../shared/IMeasuredPropertyData";
import { IKeyedInPropertyData } from "../shared/IKeyedInPropertyData";
import { IPropertySpecification, PropertySpecification } from "../shared/PropertySpecification";
import { ICalculatedPropertyData } from "../shared/ICalculatedPropertyData";
import * as CONSTANTS from "../../utilities/Constants";
export interface IProductFormData {
    requestId: string;
    isEditMode: boolean;
    id: string;
    name: string;
    description: string;
    code: string;
    grade: IGradeBasicData;
    properties: IPropertySpecification[];

    selectedGrade: any[];
}

export class ProductFormData implements IProductFormData {
    requestId: string;
    isEditMode: boolean;
    id: string;
    name: string;
    description: string;
    code: string;
    grade: IGradeBasicData;
    properties: IPropertySpecification[];

    selectedGrade: any[];

    constructor(requestId: string, isEditMode: boolean, id: string, name: string, description: string, code: string, grade: IGradeBasicData,
        measuredProperties: IMeasuredPropertyData[], keyedInProperties: IKeyedInPropertyData[], calculatedProperties: ICalculatedPropertyData[]) {

        this.requestId = requestId;
        this.isEditMode = isEditMode;
        this.id = id;
        this.name = name;
        this.description = description;
        this.code = code;
        this.grade = grade;
        this.properties = [];
        this.selectedGrade = this.grade.id ? [{
            label: this.grade.name,
            value: this.grade.id
        }] : []

        measuredProperties.forEach((element: any) => {
            const direction = (element.direction.name != CONSTANTS.ND)? " ( " + element.direction.name + ")":"";
            const propertyNameDirection = element.property.name + direction;
            this.properties.push(new PropertySpecification(true, false, element.instrument.id, element.property.id, 
                propertyNameDirection, element.property.customId,
                element.target === null ? "" : String(element.target),
                element.sigma === null ? "" : String(element.sigma), element.gain, element.offset,
                element.minValue === null ? "" : String(element.minValue), element.maxValue === null ? "" : String(element.maxValue),
                element.alarmLow1 === null ? "" : String(element.alarmLow1), element.alarmHigh1 === null ? "" : String(element.alarmHigh1),
                element.alarmLow2 === null ? "" : String(element.alarmLow2), element.alarmHigh2 === null ? "" : String(element.alarmHigh2),
                element.rejectLow === null ? "" : String(element.rejectLow), element.rejectHigh === null ? "" : String(element.rejectHigh), [],
                element.direction, element.order, element.sigmaPercent ? element.sigmaPercent : false));
        });

        keyedInProperties.forEach((element: IKeyedInPropertyData) => {
            this.properties.push(new PropertySpecification(false, false, "", element.property.id, element.property.name, element.property.customId,
                element.target === null ? "" : String(element.target),
                element.sigma === null ? "" : String(element.sigma), element.gain, element.offset,
                element.minValue === null ? "" : String(element.minValue), element.maxValue === null ? "" : String(element.maxValue),
                element.alarmLow1 === null ? "" : String(element.alarmLow1), element.alarmHigh1 === null ? "" : String(element.alarmHigh1),
                element.alarmLow2 === null ? "" : String(element.alarmLow2), element.alarmHigh2 === null ? "" : String(element.alarmHigh2),
                element.rejectLow === null ? "" : String(element.rejectLow), element.rejectHigh === null ? "" : String(element.rejectHigh), [],[], element.order, element.sigmaPercent ? element.sigmaPercent : false));
        });

        calculatedProperties.forEach((element: ICalculatedPropertyData) => {
            this.properties.push(new PropertySpecification(false, true, "", element.property.id, element.property.name, element.property.customId,
                element.target === null ? "" : String(element.target),
                element.sigma === null ? "" : String(element.sigma), element.gain, element.offset,
                element.minValue === null ? "" : String(element.minValue), element.maxValue === null ? "" : String(element.maxValue),
                element.alarmLow1 === null ? "" : String(element.alarmLow1), element.alarmHigh1 === null ? "" : String(element.alarmHigh1),
                element.alarmLow2 === null ? "" : String(element.alarmLow2), element.alarmHigh2 === null ? "" : String(element.alarmHigh2),
                element.rejectLow === null ? "" : String(element.rejectLow), element.rejectHigh === null ? "" : String(element.rejectHigh),
                [],[], element.order, element.sigmaPercent ? element.sigmaPercent : false));
        });
        this.properties?.sort((a: any, b:  any) => (a.order - b.order))
    }
}

const defaultProductFormData = new ProductFormData("", false, "", "", "", "", defaultGradeBasicData, [], [], []);
export { defaultProductFormData }